import { Spacing } from '@vkontakte/vkui';
import classNames from 'clsx';
import React, { type FC, memo, useCallback, useEffect } from 'react';
import { summerPromo2026AnalyticsName } from 'reactApp/appHelpers/featuresHelpers/features/summerPromo2026';
import { Container } from 'reactApp/sections/QuotaLanding/Container/Container';
import { Button } from 'reactApp/ui/Button/Button';
import { openSummerCampaign2026Modal } from 'reactApp/ui/SummerCampaign2026Modal/SummerCampaign2026Modal.helpers';
import { ECategoryGa, sendPaymentGa } from 'reactApp/utils/paymentGa';

import styles from './SummerPromo2026.css';

interface Props {
    isMobile: boolean;
}

export const SummerPromo2026: FC<Props> = memo(function SummerPromo2026(props) {
    const { isMobile } = props;

    useEffect(() => {
        sendPaymentGa({
            eventCategory: ECategoryGa.button,
            action: 'show',
            name: `${summerPromo2026AnalyticsName}_main`,
            dwh_enabled: true,
            dwh_enabled_fields: [['name', 'platform', 'webview']],
        });
    }, []);

    const handleButtonClick = useCallback(() => {
        sendPaymentGa({
            eventCategory: ECategoryGa.button,
            action: 'click',
            name: `${summerPromo2026AnalyticsName}_main`,
            dwh_enabled: true,
            dwh_enabled_fields: [['name', 'platform', 'webview']],
        });
        openSummerCampaign2026Modal();
    }, []);

    return (
        <>
            {!isMobile && <Spacing size={15} />}
            <Container>
                <div className={styles.root}>
                    <div className={classNames(styles.leftText, { [styles.leftTextMobile]: isMobile })}>
                        Много памяти и призы{isMobile ? '' : ' для летнего настроения'}
                    </div>
                    <Button
                        className={classNames(styles.button, { [styles.buttonMobile]: isMobile })}
                        primary
                        theme="vk"
                        onClick={handleButtonClick}
                    >
                        Забрать подарки
                    </Button>
                </div>
            </Container>
        </>
    );
});

SummerPromo2026.displayName = 'SummerPromo2026';
